module.exports = __webpack_public_path__ + "static/img/role.9cf1cee.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/cz/role.png
// module id = 9qyW
// module chunks = 7